"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "79", height: "56", viewBox: "0 0 79 56", className: "Icon payment-team", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#F4511C", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M15.875 46.321v6.238c0 .797.644 1.441 1.438 1.441h45.155c.795 0 1.438-.645 1.438-1.441V46.32c0-5.279-5.043-16.545-24.015-16.545S15.875 41.042 15.875 46.321zm-1.5 0c0-3.643 1.859-7.988 5.356-11.336 4.464-4.272 11.186-6.709 20.16-6.709 8.973 0 15.695 2.437 20.159 6.71 3.497 3.347 5.356 7.692 5.356 11.335v6.238a2.939 2.939 0 0 1-2.938 2.941H17.313a2.939 2.939 0 0 1-2.938-2.941V46.32zM39.89 23.532c5.895 0 10.674-4.82 10.674-10.766S45.785 2 39.891 2c-5.895 0-10.674 4.82-10.674 10.766s4.779 10.766 10.674 10.766zm0 1.5c-6.726 0-12.173-5.494-12.173-12.266C27.717 5.995 33.164.5 39.891.5c6.726 0 12.173 5.495 12.173 12.266 0 6.772-5.447 12.266-12.173 12.266z" }),
            _react2.default.createElement("path", { d: "M52.699 37.156v3.188c0 .407.329.737.734.737h23.08c.406 0 .735-.33.735-.737v-3.188c0-2.698-2.578-8.456-12.275-8.456-9.697 0-12.274 5.758-12.274 8.456zm-1.5 0c0-5.187 4.983-9.956 13.774-9.956 8.792 0 13.775 4.769 13.775 9.956v3.188c0 1.234-1 2.237-2.235 2.237h-23.08a2.235 2.235 0 0 1-2.234-2.237v-3.188zM64.973 23.855c2.947 0 5.337-2.41 5.337-5.383s-2.39-5.383-5.337-5.383c-2.947 0-5.337 2.41-5.337 5.383s2.39 5.383 5.337 5.383zm0 1.5c-3.779 0-6.837-3.084-6.837-6.883 0-3.798 3.058-6.883 6.837-6.883s6.837 3.085 6.837 6.883c0 3.799-3.058 6.883-6.837 6.883z" }),
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("path", { d: "M2 37.156v3.188c0 .407.329.737.735.737h23.08c.405 0 .734-.33.734-.737v-3.188c0-2.698-2.578-8.456-12.275-8.456C4.578 28.7 2 34.458 2 37.156zm-1.5 0c0-5.187 4.983-9.956 13.774-9.956 8.792 0 13.775 4.769 13.775 9.956v3.188c0 1.234-1 2.237-2.235 2.237H2.734A2.235 2.235 0 0 1 .5 40.344v-3.188zM14.274 23.855c2.948 0 5.337-2.41 5.337-5.383s-2.39-5.383-5.337-5.383c-2.947 0-5.336 2.41-5.336 5.383s2.389 5.383 5.336 5.383zm0 1.5c-3.778 0-6.836-3.084-6.836-6.883 0-3.798 3.058-6.883 6.836-6.883 3.78 0 6.837 3.085 6.837 6.883 0 3.799-3.058 6.883-6.837 6.883z" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/payment-team.js
// module id = 1824
// module chunks = 0